<!-- 朋友圈海报详情 -->
<template>
  <div>
    <el-page-header class="page-header" @back="goBack" content="朋友圈海报">
    </el-page-header>
    <div class="main">
      <div class="main-l">
        <div
          id="capture"
          v-loading="loading"
          class="capture"
          :style="captureObject"
        >
          <img
            v-if="form.bgUrl"
            class="bg"
            :src="form.bgUrl"
            alt=""
            srcset=""
          />
          <div class="capture-footer" v-if="form.setting">
            <div class="capture-footer-l">
              <div class="capture-footer-l-l">
                <img
                  width="6.0rem"
                  height="6.0rem"
                  src="../../assets/circle3@2x.png"
                  alt=""
                />
              </div>
              <div class="capture-footer-l-r">
                <p>分享人昵称</p>
                <p>分享人公司名称</p>
              </div>
            </div>
            <div class="capture-footer-r" v-if="form.qrcode">
              <img v-if="form.shareUrl" :src="form.shareUrl" alt="" srcset="" />
            </div>
          </div>
        </div>
      </div>
      <div class="main-r">
        <div class="main-r-form">
          <el-form
            ref="posterForm"
            :model="form"
            :rules="posterRules"
            label-width="9.0rem"
            label-position="left"
          >
            <el-form-item label="海报名称:" prop="title">
              <el-input
                v-model="form.title"
                maxlength="10"
                show-word-limit
                placeholder="请输入海报名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="画布尺寸:">
              750 x
              <el-input-number
                v-model="form.height"
                :min="1334"
                size="small"
              ></el-input-number>
              像素
            </el-form-item>
            <el-form-item label="背景底图:" prop="bgUrl">
              <el-upload
                class="upload-demo"
                :action="`${baseURL}/api/Alioss/uploadTotal`"
                :limit="1"
                accept="image/png, image/jpg"
                :before-upload="onBeforeUploadBg"
                :show-file-list="false"
              >
                <el-button type="primary" plain icon="el-icon-upload2"
                  >上传图片</el-button
                >
              </el-upload>
            </el-form-item>
            <el-form-item label="高级设置">
              <el-switch v-model="form.setting"></el-switch>
            </el-form-item>
            <el-form-item label="二维码:" style="margin-bottom: .8rem">
              <el-switch v-model="form.qrcode"></el-switch>
            </el-form-item>
            <template v-if="form.qrcode">
              <p class="red qrcode-tip">
                生成的二维码组件在当前页面仅作展示。在分享该海报时，将自动显示分享人的专属信息！
              </p>
              <el-form-item>
                <div class="cards">
                  <el-upload
                    :action="`${baseURL}/api/Alioss/uploadTotal`"
                    :limit="1"
                    :before-upload="onBeforeUploadFile"
                    :show-file-list="false"
                  >
                    <span class="card">
                      <i class="el-icon-tickets"></i>
                      <span>文件</span>
                    </span>
                  </el-upload>
                  <span class="card" style="margin-top: .8rem" @click="onLinkPop">
                    <i class="el-icon-link"></i>
                    <span>外部链接</span>
                  </span>
                  <el-upload
                    :action="`${baseURL}/api/Alioss/uploadTotal`"
                    :limit="1"
                    accept="image/png, image/jpg"
                    :before-upload="onBeforeUploadQrcode"
                    :show-file-list="false"
                  >
                    <span class="card">
                      <i class="el-icon-upload2"></i>
                      <span>二维码</span>
                    </span>
                  </el-upload>
                </div>
              </el-form-item>
            </template>
          </el-form>
        </div>
        <div class="main-r-footer">
          <el-button :loading="submitLoading" type="primary" @click="onSubmit"
            >提交</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog title="外部链接" center width="35%" :visible.sync="LinkdialogVisible">
      <div>
        <el-form
          ref="linkFrom"
          :model="linkFrom"
          :rules="linkRules"
          label-width="9.0rem"
        >
          <el-form-item label="外部链接:" prop="link">
            <el-input
              v-model="linkFrom.link"
              placeholder="www.weijub.com"
              size="small"
            >
              <template slot="prepend">http://</template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="LinkdialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onLinkConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import QRCode from "qrcode";

export default {
  name: "friendsPosterDetail",
  data() {
    return {
      baseURL: this.axios.defaults.baseURL,
      form: {
        title: "",
        height: 1334,
        setting: true,
        qrcode: false,
        bgUrl: "",
        type: "",
        url: "",
        shareUrl: "",
      },
      posterRules: {
        title: [{ required: true, message: "请输入海报名称", trigger: "blur" }],
        bgUrl: [{ required: true, message: "请上传背景底图", trigger: "blur" }],
      },
      linkFrom: {
        link: "",
      },
      linkRules: {
        link: [
          { required: true, message: "请输入外部链接", trigger: "blur" },
          {
            pattern: /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/,
            message: "外部链接格式不正确",
            trigger: "blur",
          },
        ],
      },
      LinkdialogVisible: false,
      loading: false,
      submitLoading: false,
    };
  },

  components: {},

  computed: {
    captureObject() {
      return {
        height: this.form.height / 2 + "px",
      };
    },
  },

  mounted() {
    if (this.$route.query.id) {
      this.getData();
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async getData() {
      const { data: res } = await this.axios({
        url: "/crm/FriendsPoster/list",
        method: "POST",
        data: this.qs.stringify({
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          id: this.$route.query.id,
        }),
      });
      if (res.code == 1) {
        const d = res.data.data[0];
        this.form.title = d.title;
        this.form.height = d.long;
        this.form.bgUrl = d.bgUrl;
        this.form.setting = !!d.setting;
        this.form.qrcode = !!d.set_qrcode;
        this.form.type = d.type;
        this.form.shareUrl = d.shareUrl;
      } else if (res.code == 0) {
        this.$message.error(res.msg);
      }
    },
    onLinkPop() {
      this.LinkdialogVisible = true;
    },
    async onLinkConfirm() {
      this.$refs.linkFrom.validate(async (valid) => {
        if (valid) {
          this.form.type = "link";
          const url = `http://${this.linkFrom.link}`;
          this.createQrCode(url);
          this.LinkdialogVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async createQrCode(url) {
      try {
        const qrcode = await QRCode.toDataURL(url, {
          margin: 1,
          padding: 2,
          width: 100,
          height: 100,
        });
        this.form.shareUrl = qrcode;
      } catch (err) {
        console.error(err);
      }
    },
    onBeforeUploadBg(file) {
      console.log(file);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (res) => {
        this.form.bgUrl = res.target.result;
      };
      return false;
    },
    onBeforeUploadFile(file) {
      this.form.type = "file";
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (res) => {
        this.form.shareUrl = res.target.result;
      };
      return false;
    },
    onBeforeUploadQrcode(file) {
      this.form.type = "qrcode";
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (res) => {
        this.form.shareUrl = res.target.result;
      };
      return false;
    },
    // 将base64转换为blob
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    async uploadFile(file) {
      let formData = new FormData();
      formData.append("file", file);
      const { data: res } = await this.axios({
        url: `${this.baseURL}/api/Alioss/uploadTotal`,
        method: "POST",
        data: formData,
      });
      if (res.code == 1) {
        this.form.url = res.data.url;
        this.onAddPoster();
      } else if (res.code == 0) {
        this.$message({
          type: "error",
          message: "图片上传失败，请检查网络或重新上传",
        });
        this.submitLoading = false;
      }
    },
    async onSubmit() {
      this.$refs.posterForm.validate(async (valid) => {
        if (valid) {
          const opts = {
            useCORS: true,
            allowTaint: false,
          };
          this.submitLoading = true;
          html2canvas(document.querySelector("#capture"), opts).then(
            (canvas) => {
              const url = canvas.toDataURL();
              let file = this.dataURLtoFile(url, `${this.form.title}.png`);
              this.uploadFile(file);
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async onAddPoster() {
      let url = "/crm/FriendsPoster/add";
      let params = {
        account_id: this.tooken.account_id,
        phone: this.tooken.phone,
        title: this.form.title,
        url: this.form.url,
        long: this.form.height,
        bgUrl: this.form.bgUrl,
        setting: this.form.setting ? 1 : 0,
        set_qrcode: this.form.qrcode ? 1 : 0,
        type: this.form.type,
        shareUrl: this.form.shareUrl,
      };
      // 编辑
      if (this.$route.query.id) {
        url = "/crm/FriendsPoster/edit";
        params.id = this.$route.query.id;
      }
      // 克隆
      if (this.$route.query.clone) {
        url = "/crm/FriendsPoster/add";
        Reflect.deleteProperty(params, "id");
      }

      const { data: res } = await this.axios({
        url,
        method: "POST",
        data: this.qs.stringify(params),
      });
      this.submitLoading = false;
      this.$message({
        type: res.code ? "success" : "error",
        message: res.msg,
      });
      if (res.code == 1) {
        setTimeout(() => {
          this.goBack();
        }, 1500);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.red {
  color: red;
}

.main {
  display: flex;
  & > div {
    padding: 1.2rem;
  }
}
.main-l {
  width: 60%;
  display: flex;
  justify-content: center;
  border-right: .1rem dashed #c7c7c7;
  .capture {
    width: 35.0rem;
    box-shadow: .2rem .2rem .2rem #ddd;
    border: .1rem solid #e8e8e8;
    background-repeat: no-repeat;
    position: relative;
    .bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
    }
    &-footer {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: .6rem 0;
      height: 10.0rem;
      &-l {
        padding-left: .8rem;
        display: flex;
        align-items: center;
        color: rgba(0, 0, 0, 0.65);
        font-size: 1.4rem;
        &-l {
          margin-right: 1.2rem;
        }
      }
      &-r {
        width: 10.0rem;
        height: 10.0rem;
        & > img {
          padding: .8rem;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
.main-r {
  font-size: 1.4rem;
  margin-left: 2.0rem;
  width: 40%;
  &-form {
    color: #333;
    .cards {
      display: flex;
      margin: 1.0rem 1.5rem 1.0rem .0rem;
      .card {
        color: #606266;
        text-align: center;
        line-height: 2.5rem;
        border-radius: .5rem;
        cursor: pointer;
        width: 8.0rem;
        height: 5.0rem;
        margin: 0 1.0rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-shadow: 0.267rem 0.267rem 0.267rem #e8e8e8;
        border: .1rem solid #e6e7eb;
        &:hover {
          border: 0.053rem solid #1890ff;
          opacity: 1;
          transform: translateY(-1.0rem);
        }
      }
    }
  }
  .qrcode {
    margin-bottom: .8rem;
  }
  .qrcode-tip {
    font-size: 1.2rem;
    margin-left: 8.0rem;
    margin-bottom: .8rem;
  }
  &-footer {
    margin-top: 2.2rem;
    display: flex;
    justify-content: center;
  }
}
</style>